module.exports = __webpack_public_path__ + "img/team.d3f0dc19.svg";